'use strict';

angular.module('ecrd.states', [
/*
    'sharecrf-sdk',
    'sharecrf.loading',
*/
]);
